import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-contact',
  templateUrl: './logo-contact.component.html',
  styleUrls: ['./logo-contact.component.css']
})
export class LogoContactComponent implements OnInit {

  contactClicked = false;
  constructor() { }

  ngOnInit(): void {
  }

  contactMelissa() {
    this.contactClicked = !this.contactClicked;
  }

}
